/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import SecondaryBtn from "../../common/form/SecondaryBtn";
import { useTranslation } from "react-i18next";
import { Add, Delete, Edit, Info, Leave, Location, SecondaryArr, Upload, UploadedProfile, Warn } from "../../common/svg/AllSvg";
import moment from "moment";
import useAxios from "../../../shared/hooks/use-axios";
import { url } from "../../../shared/utils/url";
import { useFormik } from "formik";
import * as yup from "yup";
import { components } from "react-select";
import PrimaryInput from "../../common/form/PrimaryInput";
import SelectSecondaryComponent from "../../common/form/SelectSecondaryComponent";
import PrimaryTextarea from "../../common/form/PrimaryTextarea";
import SignatureFile from "../profile/SignatureFile";
import Educations from "../profile/Educations";
import Experiences from "../profile/Experiences";
import ResumeFile from "../profile/ResumeFile";
import ExpCertiFile from "../profile/ExpCertiFile";
import EduCertificateFile from "../profile/EduCertificateFile";
import PaySlipFile from "../profile/PaySlipFile";
import GovIDFile from "../profile/GovIDFile";
import CastCertificate from "../profile/CastCertificate";
import NoneCreamyCertificate from "../profile/NoneCreamyCertificate";
import EWSCertificate from "../profile/EWSCertificate";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { dataActions } from "../../../shared/store/data-Slice";
import { numberOnPaste } from "../../../shared/utils/numberOnPaste";
import { Bounce, ToastContainer } from "react-toastify";
import { errors } from "../../../shared/utils/errors";
import { authActions } from "../../../shared/store/auth-Slice";
import { storeCookie } from "../../../shared/utils/storeCookie";

const DropdownIndicator = (props: any) => {
    return (
        components.DropdownIndicator && (
            <components.DropdownIndicator {...props}>
                <SecondaryArr />
            </components.DropdownIndicator>
        )
    );
};

const EditProfile = () => {
    const lang: string = useSelector((state: any) => state.ui.lang);
    const user: any = useSelector((state: any) => state.auth.user);
    const verifyProfile: boolean = useSelector((state: any) => state.data.verifyProfile);
    const [edit, setEdit] = useState<boolean>(false)
    const { t } = useTranslation('common');
    const [step, setStep] = useState(0);
    const steps: any[] = [t("recruitment.profile.step1"), t("recruitment.profile.step2"), t("recruitment.profile.step3")]
    const genders: any[] = [{ label: t("recruitment.profile.genders.male"), value: "male" }, { label: t("recruitment.profile.genders.female"), value: "female" }, { label: t("recruitment.profile.genders.other"), value: "other" }]
    const maritalStatus: any[] = [{ label: t("recruitment.profile.maritalStatus.unmarried"), value: "unmarried" }, { label: t("recruitment.profile.maritalStatus.married"), value: "married" }]
    const works: any[] = [{ label: t("recruitment.hr.candidate_detail.yes"), value: "yes" }, { label: t("recruitment.hr.candidate_detail.no"), value: "no" }]
    const choice: any[] = [{ label: t("recruitment.hr.candidate_detail.yes"), value: true }, { label: t("recruitment.hr.candidate_detail.no"), value: false }]
    const modes: any[] = [
        { label: t("recruitment.hr.candidate_detail.modes.full"), value: "full" },
        { label: t("recruitment.hr.candidate_detail.modes.part"), value: "part" },
        { label: t("recruitment.hr.candidate_detail.modes.online_hybrid"), value: "online_hybrid" },
        { label: t("recruitment.hr.candidate_detail.modes.distance_correspondence"), value: "distance_correspondence" },
    ]

    const results: any[] = [
        { label: t("recruitment.profile.results.passed"), value: "passed" },
        { label: t("recruitment.profile.results.appeared"), value: "appeared" },
        { label: t("recruitment.profile.results.failed"), value: "failed" },
    ]

    const employement: any[] = [
        { label: t("recruitment.profile.employement.private"), value: "private" },
        { label: t("recruitment.profile.employement.state"), value: "state" },
        { label: t("recruitment.profile.employement.psu"), value: "psu" },
        { label: t("recruitment.profile.employement.central"), value: "central" }
    ]

    const exeType: any[] = [
        { label: t("recruitment.profile.exe_type.executive"), value: "executive" },
        { label: t("recruitment.profile.exe_type.non_executive"), value: "non_executive" },
    ]

    const [categoryList, setCategoryList] = useState<any[]>([])
    const [nationalityList, setNationalityList] = useState<any[]>([])
    const [stateList, setStateList] = useState<any[]>([])
    const [createExp, setCreateExp] = useState<boolean>(true)
    const [createEdu, setCreateEdu] = useState<boolean>(true)
    const [qualificationList, setQualificationList] = useState<any[]>([])
    const [editExp, setEditExp] = useState<any>(null)
    const [editEdu, setEditEdu] = useState<any>(null)
    const [tExp, setTExp] = useState<any>(null)
    const [eTExp, setETExp] = useState<any>(null)
    const [img, setImg] = useState<string>("");
    const [imgErr, setImgErr] = useState<string>("");
    const [updImg, setUpdImg] = useState<boolean>(false);
    const [updSign, setUpdSign] = useState<boolean>(false);
    const [updResume, setUpdResume] = useState<boolean>(false);
    const [updEduCerti, setUpdEduCerti] = useState<boolean>(false);
    const [updPaySlip, setUpdPaySlip] = useState<boolean>(false);
    const [updGovID, setUpdGovID] = useState<boolean>(false);
    const [updCastCerti, setUpdCastCerti] = useState<boolean>(false);
    const [updExpCerti, setUpdExpCerti] = useState<boolean>(false)
    const [updEWSCerti, setUpdEWSCerti] = useState<boolean>(false)
    const [updNonCreamyCerti, setUpdNonCreamyCerti] = useState<boolean>(false)
    const [disExpCerti, setDisExpCerti] = useState<boolean>(false)
    const [disImg, setDisImg] = useState<boolean>(false);
    const [disSign, setDisSign] = useState<boolean>(false);
    const [disResume, setDisResume] = useState<boolean>(false);
    const [disEduCerti, setDisEduCerti] = useState<boolean>(false);
    const [disPaySlip, setDisPaySlip] = useState<boolean>(false);
    const [disGovID, setDisGovID] = useState<boolean>(false);
    const [disCastCerti, setDisCastCerti] = useState<boolean>(false);
    const [disNonCreamyCerti, setDisNonCreamyCerti] = useState<boolean>(false);
    const [disEWSCerti, setDisEWSCerti] = useState<boolean>(false);
    const [dataBind, setDataBind] = useState<boolean>(false);
    const [internal, setInternal] = useState<boolean>(false);

    const [castCertiErr, setCastCertiErr] = useState<string>('');
    const [ewsCertiErr, setEwsCertiErr] = useState<string>('');
    const [govIDErr, setGovIDErr] = useState<string>('');
    const [nonCreamyCertiErr, setNonCreamyCertiErr] = useState<string>('');
    const [resumeErr, setResumeErr] = useState<string>('');
    const [signErr, setSignErr] = useState<string>('');
    const [eduCertiErr, setEduCertiErr] = useState<string>('');
    const [paySlipErr, setPaySlipErr] = useState<string>('');
    const [expCertiErr, setExpCertiErr] = useState<string>('');

    const [castCerti, setCastCerti] = useState<any[]>([]);
    const [ewsCerti, setEwsCerti] = useState<any[]>([]);
    const [govID, setGovID] = useState<any[]>([]);
    const [nonCreamyCerti, setNonCreamyCerti] = useState<any[]>([]);
    const [resume, setResume] = useState<any[]>([]);
    const [sign, setSign] = useState<any[]>([]);
    const [eduCerti, setEduCerti] = useState<any[]>([]);
    const [paySlip, setPaySlip] = useState<any[]>([]);
    const [expCerti, setExpCerti] = useState<any[]>([]);

    const [castCertiPro, setCastCertiPro] = useState<number>(0);
    const [ewsCertiPro, setEwsCertiPro] = useState<number>(0);
    const [govIDPro, setGovIDPro] = useState<number>(0);
    const [nonCreamyCertiPro, setNonCreamyCertiPro] = useState<number>(0);
    const [resumePro, setResumePro] = useState<number>(0);
    const [signPro, setSignPro] = useState<number>(0);
    const [eduCertiPro, setEduCertiPro] = useState<number>(0);
    const [paySlipPro, setPaySlipPro] = useState<number>(0);
    const [expCertiPro, setExpCertiPro] = useState<number>(0);

    const [expDate, setExpDate] = useState<any[]>([]);
    const [eduDate, setEduDate] = useState<any[]>([]);
    const [dep, setDep] = useState<boolean>(false);
    const [data, setData] = useState<any>([])
    const [typeList, setTypeList] = useState<any[]>([])
    const [workingIdx, setWorkingIdx] = useState<any>(null)
    const [resultIdx, setResultIdx] = useState<any>(null)

    const params = useParams();
    const [submit, setSubmit] = useState<boolean>(false);
    const [subFileErr, setSubFileErr] = useState<boolean>(false);
    const [imgFocus, setImgFocus] = useState<boolean>(false)
    const dispatch = useDispatch();

    const formik: any = useFormik({
        enableReinitialize: true,
        initialValues: {
            first_name: !!data?.first_name ? data?.first_name : '',
            last_name: !!data?.last_name ? data?.last_name : '',
            email: !!data?.email ? data?.email : '',
            father_name: !!data?.father_name ? data?.father_name : '',
            spouse_name: !!data?.spouse_name ? data?.spouse_name : '',
            gender: !!data?.gender ? data?.gender : 'male',
            dob: !!data?.dob ? data?.dob : '',
            category: !!data?.category ? { label: data?.category_details?.name, value: data?.category } : '',
            nationality: !!data?.nationality ? { label: data?.nationality_details?.name, value: data?.nationality } : '',
            marital_status: !!data?.marital_status ? data?.marital_status : 'unmarried',
            mobile_no: !!data?.mobile_no ? data?.mobile_no : '',
            alt_mobile_no: !!data?.alt_mobile_no ? data?.alt_mobile_no : '',
            address: !!data?.address ? data?.address : '',
            city: !!data?.city ? data?.city : '',
            state: !!data?.state ? { label: data?.state_details?.name, value: data?.state } : '',
            zipcode: !!data?.zipcode ? data?.zipcode : '',
            signature: '',
            pic: '',
            experiences: [],
            educations: [],
            resume: '',
            certificate: '',
            payslip_docs: [],
            educational_docs: [],
            experience_docs: [],
            cast_certificate: '',
            cast_non_creamy_certificate: '',
            ews_certificate: '',
            government_id: '',
            relevant_professional_experience: !!data?.relevant_professional_experience ? data?.relevant_professional_experience : '',
            remarks: !!data?.remarks ? data?.remarks : ''
        },
        validationSchema: step === 0 ? (yup.object().shape({
            first_name: yup.string().required(t("auth.form.validation.first_name")),
            last_name: yup.string().required(t("auth.form.validation.last_name")),
            father_name: yup.string().matches(/^[A-Za-z\s]+$/, t("contact_us.form.alpha_char_err")).required(t("recruitment.profile.err.father_name")),
            spouse_name: yup.string(),
            gender: yup.string().required(t("recruitment.profile.err.gender")),
            dob: yup.date()
                .nullable()
                .typeError(t("recruitment.profile.err.valid_date"))
                .test(
                    'is-18',
                    t("recruitment.profile.err.valid_date_age"),
                    function (value: any) {
                        if (!value) return false;
                        const today = new Date();
                        const birthDate = new Date(value);
                        const age = today.getFullYear() - birthDate.getFullYear();
                        const monthDifference = today.getMonth() - birthDate.getMonth();
                        if (
                            monthDifference < 0 ||
                            (monthDifference === 0 && today.getDate() < birthDate.getDate())
                        ) {
                            return age > 18;
                        }
                        return age >= 18;
                    }
                )
                .required(t("recruitment.profile.err.dob")),
            category: yup.object().required(t("recruitment.profile.err.category")),
            nationality: yup.object().required(t("recruitment.profile.err.nationality")),
            marital_status: yup.string().required(t("recruitment.profile.err.marital_status")),
            mobile_no: yup.number().test('len', t("recruitment.profile.err.valid_mobile_no"), (val: any) => val && val.toString().length === 10).required(t("recruitment.profile.err.mobile_no")),
            email: yup.string().email(t("auth.form.validation.wrong_email")).required(t("auth.form.validation.email")),
            address: yup.string().required(t("recruitment.profile.err.address")),
            city: yup.string().required(t("recruitment.profile.err.city")),
            state: yup.object().required(t("recruitment.profile.err.state")),
            zipcode: yup.string().matches(/^[1-9]{1}[0-9]{2}\s{0,1}[0-9]{3}$/, t("recruitment.profile.err.valid_zipcode")).required(t("recruitment.profile.err.zipcode"))
        })) : step === 1 ? (yup.object().shape({
            relevant_professional_experience: yup.string().required(t("recruitment.profile.err.relevant_professional_experience")),
            remarks: !!params?.jobId ? yup.number().required(t("recruitment.profile.err.remarks")) : yup.number(),
        })) : yup.object().shape({}),
        onSubmit: async (values: any) => {
            //submit
            try {
                if (step === 0) {
                    if (!!!img && !!params?.jobId && !!signErr) {
                        setImgErr(t("recruitment.profile.err.profile_img"))
                        setSubFileErr(true)
                        return
                    }

                    if (!!!img && !!params?.jobId) {
                        setImgErr(t("recruitment.profile.err.profile_img"))
                        return
                    }

                    if (!!signErr && !!params?.jobId) {
                        setSubFileErr(true)
                        return
                    }

                    setSignErr('')
                    setSubFileErr(false)
                    setSubmit(true)
                    const formData = new FormData();
                    formData.append("first_name", values?.first_name);
                    formData.append("last_name", values?.last_name);
                    formData.append("email", values?.email);
                    formData.append("father_name", values?.father_name);
                    formData.append("spouse_name", values?.spouse_name);
                    formData.append("gender", values?.gender);
                    formData.append("dob", values?.dob);
                    formData.append("category", values?.category?.value);
                    formData.append("nationality", values?.nationality?.value);
                    formData.append("marital_status", values?.marital_status);
                    data?.mobile_no?.toString() !== values?.mobile_no?.toString() && formData.append("mobile_no", values?.mobile_no);
                    formData.append("alt_mobile_no", values?.alt_mobile_no);
                    formData.append("address", values?.address);
                    formData.append("city", values?.city);
                    formData.append("state", values?.state?.value);
                    formData.append("zipcode", values?.zipcode);
                    updSign && formData.append("signature", values?.signature);
                    updImg && formData.append("pic", values?.pic);
                    formData.append("internal_employee ", internal as any);
                    !internal && formData.append("applying_for_deputation ", dep as any);
                    const res: any = await useAxios.patch(`${(!!lang ? lang : "en") + url?.candidate_detail}${data?.id}/`, formData);

                    if (res && res?.status === 200) {
                        setSubmit(false);

                        if (data?.mobile_no?.toString() !== values?.mobile_no?.toString()) {
                            localStorage.setItem("field_value", values?.mobile_no)
                            localStorage.setItem("auth_type", "update_profile")
                            localStorage.setItem("field", "mobile")
                            localStorage.setItem("verify_type", "profile-verify")
                            dispatch(dataActions.setVerifyEmailOpen(true))
                        }
                    }
                } else if (step === 1) {
                    if (!!resultIdx && !!params?.jobId) {
                        setSubFileErr(true)
                        return
                    }

                    setSubFileErr(false)
                    setResultIdx(null)

                    let eduArr: any[] = [];
                    if (values?.educations?.length > 0) {
                        for (let index = 0; index < values?.educations.length; index++) {
                            const el = values?.educations[index];
                            let obj = { ...el }
                            delete obj["standard_name"]

                            eduArr.push(obj)
                        }
                    }

                    let expArr: any[] = [];
                    if (values?.experiences?.length > 0) {
                        for (let index = 0; index < values?.experiences.length; index++) {
                            const el = values?.experiences[index];

                            let obj = { ...el }
                            obj.currently_working?.toString() === "true" && delete obj["end_date"]
                            obj.currently_working = obj.currently_working?.toString()
                            delete obj["employment_name"]
                            delete obj["experience_type_name"]
                            delete obj["employment_type_name"]
                            if (obj?.employment !== "private") {
                                delete obj["pay_scale"]
                            } else {
                                delete obj["pay_scale_gov"]
                                delete obj["basic_pay"]
                            }

                            expArr.push(obj)
                        }
                    }
                    setSubmit(true)
                    const formData = new FormData();
                    formData.append("first_name", values?.first_name);
                    formData.append("last_name", values?.last_name);
                    formData.append("father_name", values?.father_name);
                    formData.append("spouse_name", values?.spouse_name);
                    formData.append("gender", values?.gender);
                    formData.append("dob", values?.dob);
                    formData.append("category", values?.category?.value);
                    formData.append("nationality", values?.nationality?.value);
                    formData.append("marital_status", values?.marital_status);
                    formData.append("alt_mobile_no", values?.alt_mobile_no);
                    formData.append("address", values?.address);
                    formData.append("city", values?.city);
                    formData.append("state", values?.state?.value);
                    formData.append("zipcode", values?.zipcode);
                    updSign && formData.append("signature", values?.signature);
                    updImg && formData.append("pic", values?.pic);
                    formData.append("relevant_professional_experience", values?.relevant_professional_experience);
                    formData.append("remarks", values?.remarks);
                    formData.append("internal_employee ", internal as any);
                    !internal && formData.append("applying_for_deputation ", dep as any);
                    formData.append("experiences_details", JSON.stringify(expArr));
                    formData.append("educations_details", JSON.stringify(eduArr));

                    const res: any = await useAxios.patch(`${(!!lang ? lang : "en") + url?.candidate_detail}${data?.id}/`, formData);

                    if (res && res?.status === 200) {
                        setSubmit(false);
                    }
                } else {
                    if (formik?.values?.category?.label === "OBC") {
                        if ((!!govIDErr || !!resumeErr || !!eduCertiErr || !!paySlipErr || !!expCertiErr) && !!params?.jobId) {
                            setSubFileErr(true)
                            return
                        }
                    } else if (formik?.values?.category?.label === "ST" || formik?.values?.category?.label === "SC") {
                        if ((!!govIDErr || !!resumeErr || !!eduCertiErr || !!paySlipErr || !!expCertiErr) && !!params?.jobId) {
                            setSubFileErr(true)
                            return
                        }
                    } else {
                        if ((!!govIDErr || !!resumeErr || !!eduCertiErr || !!ewsCertiErr || !!paySlipErr || !!expCertiErr) && !!params?.jobId) {
                            setSubFileErr(true)
                            return
                        }
                    }

                    setGovIDErr('')
                    setResumeErr('')
                    setEduCertiErr('')
                    setPaySlipErr('')
                    setExpCertiErr('')
                    setCastCertiErr('')
                    setNonCreamyCertiErr('')
                    setEwsCertiErr('')
                    setSubFileErr(false)

                    let eduArr: any[] = [];
                    if (values?.educations?.length > 0) {
                        for (let index = 0; index < values?.educations.length; index++) {
                            const el = values?.educations[index];
                            let obj = { ...el }
                            delete obj["standard_name"]

                            eduArr.push(obj)
                        }
                    }

                    let expArr: any[] = [];
                    if (values?.experiences?.length > 0) {
                        for (let index = 0; index < values?.experiences.length; index++) {
                            const el = values?.experiences[index];

                            let obj = { ...el }
                            obj.currently_working?.toString() === "true" && delete obj["end_date"]
                            obj.currently_working = obj.currently_working?.toString()
                            delete obj["employment_name"]
                            delete obj["experience_type_name"]
                            delete obj["employment_type_name"]
                            if (obj?.employment !== "private") {
                                delete obj["pay_scale"]
                            } else {
                                delete obj["pay_scale_gov"]
                                delete obj["basic_pay"]
                            }

                            expArr.push(obj)
                        }
                    }
                    setSubmit(true)
                    const formData = new FormData();
                    formData.append("first_name", values?.first_name);
                    formData.append("last_name", values?.last_name);
                    formData.append("father_name", values?.father_name);
                    formData.append("spouse_name", values?.spouse_name);
                    formData.append("gender", values?.gender);
                    formData.append("dob", values?.dob);
                    formData.append("category", values?.category?.value);
                    formData.append("nationality", values?.nationality?.value);
                    formData.append("marital_status", values?.marital_status);
                    formData.append("alt_mobile_no", values?.alt_mobile_no);
                    formData.append("address", values?.address);
                    formData.append("city", values?.city);
                    formData.append("state", values?.state?.value);
                    formData.append("zipcode", values?.zipcode);
                    formData.append("relevant_professional_experience", values?.relevant_professional_experience);
                    formData.append("remarks", values?.remarks);
                    updSign && formData.append("signature", values?.signature);
                    updResume && formData.append("resume", values?.resume);
                    updImg && formData.append("pic", values?.pic);
                    if (values.category?.label === "OBC") {
                        updNonCreamyCerti && formData.append("cast_non_creamy_certificate", values?.cast_non_creamy_certificate);
                        updCastCerti && formData.append("cast_certificate", values?.cast_certificate);
                    } else if (values.category?.label === "ST" || values.category?.label === "SC") {
                        updCastCerti && formData.append("cast_certificate", values?.cast_certificate);
                    } else {
                        updEWSCerti && formData.append("ews_certificate", values?.ews_certificate);
                    }
                    updGovID && formData.append("government_id", values?.government_id);
                    updEduCerti && values?.educational_docs?.map((item: any) => formData.append("educational_docs", item));
                    updExpCerti && values?.experience_docs?.map((item: any) => formData.append("experience_docs", item));
                    updPaySlip && values?.payslip_docs?.map((item: any) => formData.append("payslip_docs", item));
                    formData.append("experiences_details", JSON.stringify(expArr));
                    formData.append("educations_details", JSON.stringify(eduArr));
                    formData.append("internal_employee ", internal as any);
                    !internal && formData.append("applying_for_deputation ", dep as any);
                    const res: any = await useAxios.patch(`${(!!lang ? lang : "en") + url?.candidate_detail}${data?.id}/`, formData);

                    if (res && res?.status === 200) {
                        setSubmit(false)
                    }
                }
            } catch (error: any) {
                errors(error)
                setSubmit(false)
                console.error("error while create profile", error);
            }
        }
    });

    const handleSubmit = () => {
        if (step === 0) {
            if (!!!img && !!params?.jobId && !!signErr) {
                setImgErr(t("recruitment.profile.err.profile_img"))
                setSubFileErr(true)
                return
            }

            if (!!!img && !!params?.jobId) {
                setImgErr(t("recruitment.profile.err.profile_img"))
                return
            }

            if (!!signErr && !!params?.jobId) {
                setSubFileErr(true)
                return
            }
        }

        if (step === 1) {
            if (!!resultIdx && !!params?.jobId) {
                setSubFileErr(true)
                return
            }
        }

        if (step === 2) {
            if (formik?.values?.category?.label === "OBC") {
                if ((!!govIDErr || !!resumeErr || !!eduCertiErr || !!paySlipErr || !!expCertiErr) && !!params?.jobId) {
                    setSubFileErr(true)
                    return
                }
            } else if (formik?.values?.category?.label === "ST" || formik?.values?.category?.label === "SC") {
                if ((!!govIDErr || !!resumeErr || !!eduCertiErr || !!paySlipErr || !!expCertiErr) && !!params?.jobId) {
                    setSubFileErr(true)
                    return
                }
            } else {
                if ((!!govIDErr || !!resumeErr || !!eduCertiErr || !!ewsCertiErr || !!paySlipErr || !!expCertiErr) && !!params?.jobId) {
                    setSubFileErr(true)
                    return
                }
            }
        }
    }

    useEffect(() => {
        if (verifyProfile) {
            let profileUser: any = { ...user }
            profileUser.first_name = !!formik?.values?.first_name ? formik?.values?.first_name : profileUser?.first_name
            profileUser.last_name = !!formik?.values?.last_name ? formik?.values?.last_name : profileUser?.last_name
            profileUser.phone = !!formik?.values?.mobile_no ? formik?.values?.mobile_no : profileUser?.phone
            profileUser.email = !!formik?.values?.email ? formik?.values?.email : profileUser?.email
            profileUser.username = !!formik?.values?.email ? formik?.values?.email : profileUser?.email

            storeCookie({ data: profileUser }, null)
            dispatch(authActions.userDetail(profileUser))
            dispatch(dataActions.setVerifyProfile(false))
        }
    }, [verifyProfile])

    const getCategory = async () => {
        try {
            const res: any = await useAxios.get(`/${(!!lang ? lang : "en") + url?.category}`);

            if (res && res.status === 200) {
                res?.data?.results?.length > 0 && setCategoryList(res?.data?.results?.map((item: any) => ({ label: item?.text, value: item?.id })))
            }
        } catch (error) {
            console.error("error while fetching category", error);
        }
    }

    const getNationality = async () => {
        try {
            const res: any = await useAxios.get(`/${(!!lang ? lang : "en") + url?.nationality}`);

            if (res && res.status === 200) {
                res?.data?.results?.length > 0 && setNationalityList(res?.data?.results?.map((item: any) => ({ label: item?.text, value: item?.id })))
            }
        } catch (error) {
            console.error("error while fetching nationality", error);
        }
    }

    const getState = async () => {
        try {
            const res: any = await useAxios.get(`/${(!!lang ? lang : "en") + url?.state}`);

            if (res && res.status === 200) {
                res?.data?.results?.length > 0 && setStateList(res?.data?.results?.map((item: any) => ({ label: item?.text, value: item?.id })))
            }
        } catch (error) {
            console.error("error while fetching state", error);
        }
    }

    const getQualification = async () => {
        try {
            const res: any = await useAxios.get(`/${(!!lang ? lang : "en") + url?.qualificationList}`);

            if (res && res.status === 200) {
                res?.data?.results?.length > 0 && setQualificationList(res?.data?.results?.map((item: any) => ({ label: item?.text, value: item?.id })))
            }
        } catch (error) {
            console.error("error while fetching qualification", error);
        }
    }

    const getData = async () => {
        try {
            const res: any = await useAxios.get(`/${(!!lang ? lang : "en") + url?.candidate_detail}`);

            if (res && res.status === 200 && res?.data?.length > 0) {
                setData(res?.data?.[0])
                !!res?.data?.[0]?.pic_details && setImg(res?.data?.[0]?.pic_details?.aws_file_url)
                res?.data?.[0]?.internal_employee ? setInternal(true) : setInternal(false)
                res?.data?.[0]?.applying_for_deputation ? setDep(true) : setDep(false)

                let profileUser: any = { ...user }
                profileUser.first_name = !!res?.data?.[0]?.first_name ? res?.data?.[0]?.first_name : profileUser?.first_name
                profileUser.last_name = !!res?.data?.[0]?.last_name ? res?.data?.[0]?.last_name : profileUser?.last_name
                profileUser.phone = !!res?.data?.[0]?.mobile_no ? res?.data?.[0]?.mobile_no : profileUser?.phone
                profileUser.email = !!res?.data?.[0]?.email ? res?.data?.[0]?.email : profileUser?.email
                profileUser.username = !!res?.data?.[0]?.email ? res?.data?.[0]?.email : profileUser?.email

                storeCookie({ data: profileUser }, null)
                dispatch(authActions.userDetail(profileUser))
            }
        } catch (error) {
            console.error("error while fetching candidate details", error);
        }
    }

    const getEmpNature = async () => {
        try {
            const res: any = await useAxios.get(`/${(!!lang ? lang : "en") + url?.empNature}`);

            if (res && res.status === 200) {
                res?.data?.results?.length > 0 && setTypeList(res?.data?.results?.map((item: any) => ({ label: item?.text, value: item?.id })))
            }
        } catch (error) {
            console.error("error while fetching employee nature", error);
        }
    }

    useEffect(() => {
        if (!!lang) {
            getCategory();
            getNationality();
            getState();
            getQualification();
            getData();
            getEmpNature();
        }
    }, [lang])

    const handleUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
        setImgErr("")
        let files: any = e.target.files;
        if (!files) return;

        if (!files[0].name.match(/\.(jpg|jpeg|png|JPG|JPEG|PNG)$/)) {
            setImgErr(t("passenger.lost_found.report_form.validation.valid_file"));
            return;
        }

        if (files[0].size > (5 * 1000 * 1024)) {
            setImgErr(t("passenger.lost_found.report_form.validation.size_err"));
            return;
        }

        const pImg: any = new Image();
        pImg.src = URL.createObjectURL(files[0]);
        pImg.onload = async () => {
            const width: any = await pImg.naturalWidth;
            const height: any = await pImg.naturalHeight;
            if (width > 300 && height > 300) {
                setImgErr(t("passenger.lost_found.report_form.validation.img_size_err"));
                return;
            } else {
                setDisImg(true)
                setImg(URL.createObjectURL(files[0]));
                setUpdImg(true)
                formik.setFieldValue("pic", files[0]);
                (document.getElementById('pic') as any).value = '';
                setDisImg(false)
            }
        }

    }

    const removeExp = (idx: number) => {
        let arr: any[] = [];
        for (let i = 0; i < formik?.values?.experiences.length; i++) {
            const el = formik?.values?.experiences[i];

            if (idx !== i) {
                arr.push(el)
            }
        }

        if ((idx + 1) === workingIdx) setWorkingIdx(null)
        let arr1: any[] = expDate?.filter((item: any, index: number) => index !== idx)
        setExpDate(arr1)
        formik.setFieldValue("experiences", arr)
    };

    const removeEdu = (idx: number) => {
        let arr: any[] = [];
        for (let i = 0; i < formik?.values?.educations.length; i++) {
            const el = formik?.values?.educations[i];

            if (idx !== i) {
                arr.push(el)
            }
        }
        if ((idx + 1) === resultIdx) setResultIdx(null)
        let arr1: any[] = eduDate?.filter((item: any, index: number) => index !== idx)
        setEduDate(arr1)
        formik.setFieldValue("educations", arr)
    };

    useEffect(() => {
        if (Object?.keys(formik?.errors)?.length === 0) {
            formik.setTouched({});
        }
    }, [formik?.errors, step])

    useEffect(() => {
        if (step === 1 && !!data && !dataBind) {
            if (data?.experiences?.length > 0) {
                let arr: any[] = [...formik?.values?.experiences]
                for (let index = 0; index < data?.experiences.length; index++) {
                    const obj = data?.experiences[index];
                    let el: any = {}
                    el.company_name = !!obj?.company_name ? obj?.company_name : ''
                    el.job_title = !!obj?.job_title ? obj?.job_title : ''
                    el.currently_working = obj?.currently_working
                    el.start_date = !!obj?.start_date ? obj?.start_date : ''
                    el.end_date = !!obj?.end_date ? obj?.end_date : ''
                    el.location = !!obj?.location ? obj?.location : ''
                    el.gap_reason = !!obj?.gap_reason ? obj?.gap_reason : ''
                    el.experience_type = !!obj?.experience_type ? obj?.experience_type : ''
                    el.experience_type_name = !!obj?.experience_type ? obj?.experience_type : ''
                    el.employment_name = !!obj?.employment ? obj?.employment : ''
                    el.employment = !!obj?.employment ? obj?.employment : ''
                    el.nature_of_work = !!obj?.nature_of_work ? obj?.nature_of_work : ''
                    el.employment_type_id = !!obj?.employment_type ? obj?.employment_type : ''
                    el.employment_type_name = !!obj?.employment_type_details?.name ? obj?.employment_type_details?.name : ''

                    if (!!obj?.employment && obj?.employment !== "private") {
                        el["pay_scale_gov"] = !!obj?.pay_scale_gov ? obj?.pay_scale_gov : ''
                        el["basic_pay"] = !!obj?.basic_pay ? obj?.basic_pay : ''
                    }

                    if (!!obj?.employment && obj?.employment === "private") {
                        el["pay_scale"] = !!obj?.pay_scale ? obj?.pay_scale : ''
                    }

                    if (obj?.currently_working) {
                        setWorkingIdx(index + 1)
                        setExpDate([...expDate, { min: obj?.start_date, max: new Date().toISOString().split("T")[0] }])
                    }
                    else {
                        setExpDate([...expDate, { min: obj?.start_date, max: obj?.end_date }])
                    }

                    arr.push(el)
                }
                arr.length > 0 && setCreateExp(false)
                formik.setFieldValue("experiences", arr)
            }
            if (data?.educations?.length > 0) {
                let arr: any[] = [...formik?.values?.educations]
                for (let index = 0; index < data?.educations.length; index++) {
                    const obj = data?.educations[index];
                    let el: any = {}
                    el.institute_name = !!obj?.institute_name ? obj?.institute_name : ''
                    el.specialization_name = !!obj?.specialization_name ? obj?.specialization_name : ''
                    el.board_name = !!obj?.board_name ? obj?.board_name : ''
                    el.standard_id = !!obj?.standard ? obj?.standard : ''
                    el.standard_name = !!obj?.standard_details?.name ? obj?.standard_details?.name : ''
                    el.start_date = !!obj?.start_date ? obj?.start_date : ''
                    el.end_date = !!obj?.end_date ? obj?.end_date : ''
                    el.per_cgpa = !!obj?.per_cgpa ? obj?.per_cgpa : ''
                    el.description = !!obj?.description ? obj?.description : ''
                    el.result = !!obj?.result ? obj?.result : ''
                    el.mode = !!obj?.mode ? obj?.mode : ''

                    if (obj?.result === "failed") {
                        setResultIdx(index + 1)
                    }
                    arr.push(el)
                    setEduDate([...eduDate, { min: obj?.start_date, max: obj?.end_date }])
                }
                arr.length > 0 && setCreateEdu(false)
                formik.setFieldValue("educations", arr)
            }
            setDataBind(true)
        }
    }, [step, data, dataBind])

    const calculateExperience = (fromDate: any, toDate: any) => {
        const startDate = new Date(fromDate);
        const endDate = new Date(toDate);

        let years = endDate.getFullYear() - startDate.getFullYear();
        let months = endDate.getMonth() - startDate.getMonth();
        let days = endDate.getDate() - startDate.getDate();

        if (days < 0) {
            months -= 1;
            days += new Date(endDate.getFullYear(), endDate.getMonth(), 0).getDate();
        }

        if (months < 0) {
            years -= 1;
            months += 12;
        }

        return { years, months, days };
    }

    const calculateTotalExperience = (datePairs: any) => {
        let totalYears = 0, totalMonths = 0, totalDays = 0;

        datePairs.forEach((pair: any) => {
            const experience = calculateExperience(pair.from, pair.to);

            totalYears += experience.years;
            totalMonths += experience.months;
            totalDays += experience.days;
        });

        if (totalDays >= 30) {
            totalMonths += Math.floor(totalDays / 30);
            totalDays = totalDays % 30;
        }

        if (totalMonths >= 12) {
            totalYears += Math.floor(totalMonths / 12);
            totalMonths = totalMonths % 12;
        }

        return { totalYears, totalMonths, totalDays };
    }

    useEffect(() => {
        if (formik?.values?.experiences?.length > 0) {
            let arr: any[] = [];
            let arr1: any[] = [];
            let arr2: any[] = [];
            for (let i = 0; i < formik?.values?.experiences.length; i++) {
                const el = formik?.values?.experiences[i];



                if (el?.currently_working?.toString() === "true") {
                    if (el?.experience_type_name?.toLowerCase() === "executive") {
                        arr1.push({ from: moment(el?.start_date).format("YYYY-MM-DD"), to: moment(new Date()).format("YYYY-MM-DD") })
                    }
                    arr.push({ from: moment(el?.start_date).format("YYYY-MM-DD"), to: moment(new Date()).format("YYYY-MM-DD") })
                    arr2.push(i + 1)
                } else {
                    if (el?.experience_type_name?.toLowerCase() === "executive") {
                        arr1.push({ from: moment(el?.start_date).format("YYYY-MM-DD"), to: moment(el?.end_date).format("YYYY-MM-DD") })
                    }
                    arr.push({ from: moment(el?.start_date).format("YYYY-MM-DD"), to: moment(el?.end_date).format("YYYY-MM-DD") })
                }
            }

            if (arr?.length > 0) {
                const totalExperience = calculateTotalExperience(arr);
                setTExp(totalExperience)
            } else {
                setTExp(null)
            }

            if (arr1?.length > 0) {
                const totalExperience = calculateTotalExperience(arr1);
                setETExp(totalExperience)
            } else {
                setETExp(null)
            }

            if (arr2?.length > 0) {
                setWorkingIdx(arr2[arr2?.length - 1])
            } else {
                setWorkingIdx(null)
            }
        }
    }, [formik?.values?.experiences])

    useEffect(() => {
        if (formik?.values?.educations?.length > 0) {
            let arr: any[] = []
            for (let index = 0; index < formik?.values?.educations.length; index++) {
                const el = formik?.values?.educations[index];

                if (el?.result === "failed") {
                    setResultIdx(index + 1)
                    arr.push(el)
                }
            }

            arr?.length === 0 && setResultIdx(null)
        }
    }, [formik?.values?.educations])

    useEffect(() => {
        if (!!workingIdx) {
            setInternal(false)
        } else {
            data?.internal_employee ? setInternal(true) : setInternal(false)
        }
    }, [workingIdx, data])

    const handleEdit = () => {
        if (edit) {
            handleSubmit();
            formik?.handleSubmit();
        } else {
            setEdit(true)
        }
    }

    useEffect(() => {
        if (edit) {
            const handleBeforeUnload = (event: any) => {
                event.preventDefault();
                event.returnValue = '';
            };
            window.addEventListener('beforeunload', handleBeforeUnload);

            return () => {
                window.removeEventListener('beforeunload', handleBeforeUnload);
            };
        }
    }, [edit]);

    return (
        <div className="flex flex-col w-full">
            <ToastContainer
                position="top-center"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
                transition={Bounce}
            />

            <div className="w-full flex items-center justify-between pb-[20px] px-[15px] md:p-[30px] xlx:p-[35px] border-b border-primary border-opacity-[0.2] gap-[15px]">
                <div className="flex flex-col gap-[5px]">
                    <h3 className="text-primaryText dark:text-white font-semibold">{t("recruitment.profile.edit_profile.title")}</h3>
                    <h6 className="text-blackDull dark:text-textBlackDull font-medium xsm:max-w-max max-w-[200px]">{t("recruitment.profile.edit_profile.desc")}</h6>
                </div>

                <SecondaryBtn css={`!rounded-[6px] ${!edit ? "px-[12px]" : "px-[24px]"} font-semibold !h-[35px] !gap-[8px] !text-base`} title={!edit ? t("profile.edit") : t("recruitment.hr.create_ad.field.save")} leftIcon={!edit && <Edit className="w-[17px] h-[17px] fill-white" />}
                    onClick={handleEdit}
                    disabled={edit ? (step === 0 ? (disSign || disImg || submit) : step === 1 ? (submit) : (submit || disCastCerti || disEduCerti || disGovID || disPaySlip || disResume || disExpCerti || disEWSCerti || disNonCreamyCerti)) : false}
                />
            </div>

            <div className="flex items-center gap-[8px] w-full border-b border-primary border-opacity-[0.2] px-[15px] md:px-[30px] xlx:px-[35px] overflow-x-auto">
                {Array.isArray(steps) && steps?.map((item: any, index: number) => (
                    <button key={index} className={`${step === index ? "text-primaryText dark:text-white border-b-[2px] border-primary" : "text-blackDull dark:text-textBlackDull focus:text-primaryText hover:text-primaryText dark:focus:text-white dark:hover:text-white focus:underline hover:underline border-b-[2px] border-transparent"} capitalize text-sm font-medium py-[6px] px-[16px] whitespace-nowrap`} onClick={() => setStep(index)}>{item}</button>
                ))}
            </div>

            <div className="flex gap-[40px] xlx:gap-[50px] py-[20px] px-[15px] md:p-[30px] xlx:px-[35px] xlx:py-[50px] xsm:flex-row flex-col w-full">
                {step === 0 &&
                    <>
                        {/* profile photo */}
                        <div className="flex flex-col xsm:items-center gap-[15px] min-w-[120px]">
                            <div className="flex flex-col xsm:items-center gap-[4px]">
                                <div className="bg-[#F5F5F5] dark:bg-bgDark rounded-full w-[100px] h-[100px] flex items-center justify-center relative">
                                    {!!img ? <img src={img} alt="pic" className="w-[100px] h-[100px] object-contain rounded-full" title='' /> : <UploadedProfile className="stroke-primary dark:stroke-bgPrimaryDark" />}

                                    {!!img && <div className="absolute right-0 bottom-0">
                                        <div className={`relative min-w-[28px] h-[28px] flex items-center justify-center border border-[#E2E2E2] bg-white shadow-[0px_9.045px_31.656px_-6.783px_rgba(24,39,75,0.12),0px_20.35px_99.49px_-4.522px_rgba(24,39,75,0.14)] rounded-full ${imgFocus && "focus:shadow-[0_0_0_3px_#059db25e]"} ${!edit ? "opacity-[0.7]" : "hover:shadow-[0_0_0_3px_#059db25e]"}`}>
                                            <input type="file" id="pic" onChange={handleUpload} className="opacity-0 absolute top-0 left-0 right-0 bottom-0 z-[1] w-full h-full" title='' multiple={false} onFocus={() => setImgFocus(true)} onBlur={() => setImgFocus(false)} disabled={!edit} />
                                            <Edit className="fill-primary" aria-label={t("aria_label.edit_profile_img")} title={t("aria_label.edit_profile_img")} disabled={!edit} />
                                        </div>
                                    </div>}
                                </div>

                                {(!!imgErr && !!img) && <div className="flex gap-[6px] items-start max-w-[110px]"><Warn />
                                    <span className="text-danger dark:text-darkDanger text-xs font-medium">{imgErr}</span>
                                </div>}
                            </div>
                            {!!!img && <div className="relative h-fit w-fit">
                                <input type="file" id="pic" onChange={handleUpload} className="opacity-0 absolute top-0 left-0 right-0 bottom-0 z-[1] w-full h-full" title='' multiple={false} disabled={!edit} onFocus={() => setImgFocus(true)} onBlur={() => setImgFocus(false)} />

                                <div className="flex flex-col gap-[4px]">
                                    <div className={`flex items-center gap-[10px] ${!edit ? "opacity-[0.7]" : "hover:underline"} text-primary ${imgFocus && "underline"}`}>
                                        <Upload />
                                        <h6 className="text-primary font-semibold">{t("recruitment.profile.field.upload_pic")}</h6>
                                    </div>
                                    {!!imgErr && <div className="flex gap-[6px] items-start max-w-[110px]"><Warn />
                                        <span className="text-danger dark:text-darkDanger text-xs font-medium">{imgErr}</span>
                                    </div>}
                                </div>
                            </div>}
                        </div>

                        <div className="w-full lgl:w-[580px] h-full flex flex-col gap-[15px] xsm:gap-[20px] xlx:gap-[30px]">
                            <div className="flex items-center gap-[8px] xlx:gap-[12px]">
                                <h5 className="text-primaryText dark:text-white font-bold whitespace-nowrap">{t("recruitment.profile.field.personal_details")}</h5>
                                <div className="border-b border-primaryText dark:border-white w-full border-opacity-[0.6]"></div>
                            </div>

                            <div className="grid w-full grid-cols-1 msm:grid-cols-2 gap-[15px] xlx:gap-[20px]">
                                <div className="flex flex-col gap-[4px]">
                                    <PrimaryInput title={`${t("recruitment.profile.field.first_name")}*`} name="first_name" type="text" placeholder={t("recruitment.profile.field.first_name")} value={formik?.values?.first_name} onBlur={formik?.handleBlur} onChange={formik?.handleChange} disabled={!edit} />
                                    {formik?.touched?.first_name && formik?.errors?.first_name && <div className="flex gap-[6px] items-start"><Warn />
                                        <span className="text-danger dark:text-darkDanger text-xs font-medium">{formik?.errors?.first_name}</span>
                                    </div>}
                                </div>

                                <div className="flex flex-col gap-[4px]">
                                    <PrimaryInput title={`${t("recruitment.profile.field.last_name")}*`} name="last_name" type="text" placeholder={t("recruitment.profile.field.last_name")} value={formik?.values?.last_name} onBlur={formik?.handleBlur} onChange={formik?.handleChange} disabled={!edit} />
                                    {formik?.touched?.last_name && formik?.errors?.last_name && <div className="flex gap-[6px] items-start"><Warn />
                                        <span className="text-danger dark:text-darkDanger text-xs font-medium">{formik?.errors?.last_name}</span>
                                    </div>}
                                </div>
                            </div>

                            <div className="grid w-full grid-cols-1 msm:grid-cols-2 gap-[15px] xlx:gap-[20px]">
                                <div className="flex flex-col gap-[4px]">
                                    <PrimaryInput title={`${t("recruitment.profile.field.father_name")}*`} name="father_name" type="text" placeholder={t("recruitment.profile.field.father_name")} value={formik?.values?.father_name} onBlur={formik?.handleBlur} onChange={formik?.handleChange} disabled={!edit} />
                                    {formik?.touched?.father_name && formik?.errors?.father_name && <div className="flex gap-[6px] items-start"><Warn />
                                        <span className="text-danger dark:text-darkDanger text-xs font-medium">{formik?.errors?.father_name}</span>
                                    </div>}
                                </div>

                                <div className="flex flex-col gap-[4px]">
                                    <PrimaryInput title={`${t("recruitment.profile.field.dob")}*`} name="dob" type="date" placeholder={t("recruitment.profile.field.dob")} value={formik?.values?.dob} onBlur={formik?.handleBlur} onChange={formik?.handleChange} disabled={!edit} />
                                    {formik?.touched?.dob && formik?.errors?.dob && <div className="flex gap-[6px] items-start"><Warn />
                                        <span className="text-danger dark:text-darkDanger text-xs font-medium">{formik?.errors?.dob}</span>
                                    </div>}
                                </div>
                            </div>

                            <div className="flex flex-col gap-[4px]">
                                <h6 className="text-blackDark dark:text-textBlackDark font-medium">{`${t("recruitment.profile.field.gender")}*`}</h6>

                                <div className="flex items-center gap-[10px]">
                                    {Array.isArray(genders) && genders?.map((item: any, index: number) => (
                                        <button key={index} className={`${formik?.values?.gender === item?.value ? "border border-primary bg-primary text-white focus:shadow-[0_0_0_2px_#059db25e] hover:shadow-[0_0_0_2px_#059db25e]" : "border border-blackDull bg-white text-blackDull focus:shadow-[0_0_0_2px_#4e566d5e] hover:shadow-[0_0_0_2px_#4e566d5e] dark:focus:shadow-[0_0_0_2px_#ffffff5e] dark:hover:shadow-[0_0_0_2px_#ffffff5e]"} rounded-[10px] h-[35px] xlx:h-[40px] px-[12px] text-sm leading-snug font-normal disabled:opacity-[0.7] disabled:shadow-none disabled:dark:shadow-none`} onClick={() => formik.setFieldValue("gender", item?.value)} disabled={!edit}>{item?.label}</button>
                                    ))}
                                </div>
                            </div>

                            <div className="grid w-full grid-cols-1 md:grid-cols-2 gap-[15px] xlx:gap-[20px]">
                                <div className="flex flex-col gap-[4px]">
                                    <h6 className="text-blackDark dark:text-textBlackDark font-medium">{`${t("recruitment.profile.field.category")}*`}</h6>
                                    <SelectSecondaryComponent
                                        options={categoryList}
                                        name="category"
                                        placeholder={t("recruitment.profile.placehoder.category")}
                                        isSearchable={false}
                                        arrow={true}
                                        components={{ DropdownIndicator }}
                                        onChange={(e: any) => formik.setFieldValue("category", e)}
                                        onBlur={(e: any) => formik.setFieldTouched("category", e)}
                                        value={!!formik.values.category ? categoryList?.find((item: any) => item?.value === formik.values.category?.value) : formik.values.category}
                                        isDisabled={!edit}
                                    />
                                    {formik?.touched?.category && formik?.errors?.category && <div className="flex gap-[6px] items-start"><Warn />
                                        <span className="text-danger dark:text-darkDanger text-xs font-medium">{formik?.errors?.category}</span>
                                    </div>}
                                </div>
                                <div className="flex flex-col gap-[4px]">
                                    <h6 className="text-blackDark dark:text-textBlackDark font-medium">{`${t("recruitment.profile.field.nationality")}*`}</h6>
                                    <SelectSecondaryComponent
                                        options={nationalityList}
                                        name="nationality"
                                        placeholder={t("recruitment.profile.placehoder.nationality")}
                                        isSearchable={false}
                                        arrow={true}
                                        components={{ DropdownIndicator }}
                                        onChange={(e: any) => formik.setFieldValue("nationality", e)}
                                        onBlur={(e: any) => formik.setFieldTouched("nationality", e)}
                                        value={!!formik.values.nationality ? nationalityList?.find((item: any) => item?.value === formik.values.nationality?.value) : formik.values.nationality}
                                        isDisabled={!edit}
                                    />
                                    {formik?.touched?.nationality && formik?.errors?.nationality && <div className="flex gap-[6px] items-start"><Warn />
                                        <span className="text-danger dark:text-darkDanger text-xs font-medium">{formik?.errors?.nationality}</span>
                                    </div>}
                                </div>
                            </div>

                            <div className="grid w-full grid-cols-1 md:grid-cols-2 gap-[15px] xlx:gap-[20px]">
                                <div className="flex flex-col gap-[4px]">
                                    <h6 className="text-blackDark dark:text-textBlackDark font-medium">{`${t("recruitment.profile.field.marital_status")}*`}</h6>

                                    <div className="flex items-center gap-[10px]">
                                        {Array.isArray(maritalStatus) && maritalStatus?.map((item: any, index: number) => (
                                            <button key={index} className={`${formik?.values?.marital_status === item?.value ? "border border-primary bg-primary text-white focus:shadow-[0_0_0_2px_#059db25e] hover:shadow-[0_0_0_2px_#059db25e]" : "border border-blackDull bg-white text-blackDull focus:shadow-[0_0_0_2px_#4e566d5e] hover:shadow-[0_0_0_2px_#4e566d5e] dark:focus:shadow-[0_0_0_2px_#ffffff5e] dark:hover:shadow-[0_0_0_2px_#ffffff5e]"} rounded-[10px] h-[35px] xlx:h-[40px] px-[12px] text-sm leading-snug font-normal disabled:opacity-[0.7] disabled:shadow-none disabled:dark:shadow-none`} disabled={!edit} onClick={() => formik.setFieldValue("marital_status", item?.value)}>{item?.label}</button>
                                        ))}
                                    </div>
                                </div>

                                <div className="flex flex-col gap-[4px]">
                                    <PrimaryInput title={t("recruitment.profile.field.spouse_name")} name="spouse_name" type="text" placeholder={t("recruitment.profile.field.spouse_name")} value={formik?.values?.spouse_name} onBlur={formik?.handleBlur} onChange={formik?.handleChange} disabled={!edit} />
                                    {formik?.touched?.spouse_name && formik?.errors?.spouse_name && <div className="flex gap-[6px] items-start"><Warn />
                                        <span className="text-danger dark:text-darkDanger text-xs font-medium">{formik?.errors?.spouse_name}</span>
                                    </div>}
                                </div>
                            </div>

                            <div className="flex items-center gap-[8px] xlx:gap-[12px] mt-[10px] xlx:mt-[20px]">
                                <h5 className="text-primaryText dark:text-white font-bold whitespace-nowrap">{t("recruitment.profile.field.contact_details")}</h5>
                                <div className="border-b border-primaryText dark:border-white w-full border-opacity-[0.6]"></div>
                            </div>

                            <div className="grid w-full grid-cols-1 md:grid-cols-2 gap-[15px] xlx:gap-[20px]">
                                <div className="flex flex-col gap-[4px]">
                                    <h6 className="text-blackDark dark:text-textBlackDark font-medium">{`${t("recruitment.profile.field.mobile_no")}*`}</h6>
                                    <div className="flex items-center gap-[10px] w-full">
                                        <input className="flex items-center justify-center px-[7px] w-[35px] xlx:w-[40px] h-[35px] xlx:h-[40px] rounded-[6px] hover:bg-white focus:bg-white  bg-[#F5F5F5] border border-[#D7D8DD] text-blackDull text-sm leading-snug dark:bg-bgDark dark:hover:bg-bgDarkDull dark:focus:bg-bgDarkDull dark:border-[#454545] dark:text-textBlackDull placeholder:dark:text-textBlackDull disabled:hover:bg-[#F5F5F5] disabled:dark:hover:bg-bgDark disabled:opacity-[0.7]" defaultValue="+91" disabled autoComplete="off" />
                                        <input className="placeholder:text-blackDull w-full rounded-[6px] hover:bg-white focus:bg-white  bg-[#F5F5F5] border border-[#D7D8DD] h-[35px] xlx:h-[40px] px-[15px] xlx:px-[17px] text-blackDull text-sm leading-snug dark:bg-bgDark dark:hover:bg-bgDarkDull dark:focus:bg-bgDarkDull dark:border-[#454545] dark:text-textBlackDull placeholder:dark:text-textBlackDull disabled:opacity-[0.7] disabled:hover:bg-[#F5F5F5] disabled:dark:hover:bg-bgDark" type="number" name="mobile_no" placeholder={t("recruitment.profile.field.mobile_no")} autoComplete="off" value={formik?.values?.mobile_no} onBlur={formik?.handleBlur} onChange={formik?.handleChange} onFocus={(e: any) => e.target.addEventListener("wheel", function (e: any) { e.preventDefault() }, { passive: false })}
                                            onKeyDown={(e: any) => ["e", "E", "+", "-", "."].includes(e.key) && e.preventDefault()} disabled={!edit} onPaste={(e: any) => numberOnPaste(e)} />
                                    </div>
                                    {formik?.touched?.mobile_no && formik?.errors?.mobile_no && <div className="flex gap-[6px] items-start"><Warn />
                                        <span className="text-danger dark:text-darkDanger text-xs font-medium">{formik?.errors?.mobile_no}</span>
                                    </div>}
                                </div>

                                <div className="flex flex-col gap-[4px]">
                                    <h6 className="text-blackDark dark:text-textBlackDark font-medium">{t("recruitment.profile.field.alt_mobile_no")}</h6>
                                    <div className="flex items-center gap-[10px] w-full">
                                        <input className="flex items-center justify-center px-[7px] w-[35px] xlx:w-[40px] h-[35px] xlx:h-[40px] rounded-[6px] hover:bg-white focus:bg-white  bg-[#F5F5F5] border border-[#D7D8DD] text-blackDull text-sm leading-snug dark:bg-bgDark dark:hover:bg-bgDarkDull dark:focus:bg-bgDarkDull dark:border-[#454545] dark:text-textBlackDull placeholder:dark:text-textBlackDull disabled:hover:bg-[#F5F5F5] disabled:dark:hover:bg-bgDark disabled:opacity-[0.7]" defaultValue="+91" disabled autoComplete="off" />
                                        <input className="placeholder:text-blackDull w-full rounded-[6px] hover:bg-white focus:bg-white  bg-[#F5F5F5] border border-[#D7D8DD] h-[35px] xlx:h-[40px] px-[15px] xlx:px-[17px] text-blackDull text-sm leading-snug dark:bg-bgDark dark:hover:bg-bgDarkDull dark:focus:bg-bgDarkDull dark:border-[#454545] dark:text-textBlackDull placeholder:dark:text-textBlackDull disabled:hover:bg-[#F5F5F5] disabled:dark:hover:bg-bgDark disabled:opacity-[0.7]" type="number" name="alt_mobile_no" placeholder={t("recruitment.profile.field.alt_mobile_no")} autoComplete="off" value={formik?.values?.alt_mobile_no} onBlur={formik?.handleBlur} onChange={formik?.handleChange} onFocus={(e: any) => e.target.addEventListener("wheel", function (e: any) { e.preventDefault() }, { passive: false })}
                                            onKeyDown={(e: any) => ["e", "E", "+", "-", "."].includes(e.key) && e.preventDefault()} onPaste={(e: any) => numberOnPaste(e)} disabled={!edit} />
                                    </div>
                                    {formik?.touched?.alt_mobile_no && formik?.errors?.alt_mobile_no && <div className="flex gap-[6px] items-start"><Warn />
                                        <span className="text-danger dark:text-darkDanger text-xs font-medium">{formik?.errors?.alt_mobile_no}</span>
                                    </div>}
                                </div>
                            </div>

                            <div className="grid w-full grid-cols-1 md:grid-cols-2 gap-[15px] xlx:gap-[20px]">
                                <div className="flex flex-col gap-[4px]">
                                    <PrimaryInput title={`${t("recruitment.profile.field.email")}*`} name="email" type="email" placeholder={t("recruitment.profile.placehoder.email")} value={formik?.values?.email} onBlur={formik?.handleBlur} onChange={formik?.handleChange} disabled={!edit} />
                                    {formik?.touched?.email && formik?.errors?.email && <div className="flex gap-[6px] items-start"><Warn />
                                        <span className="text-danger dark:text-darkDanger text-xs font-medium">{formik?.errors?.email}</span>
                                    </div>}
                                </div>
                            </div>

                            <div className="flex flex-col gap-[4px]">
                                <PrimaryTextarea title={`${t("recruitment.profile.field.address")}*`} placeholder={t("recruitment.profile.placehoder.address")} name="address" rows="4" value={formik?.values?.address} onBlur={formik?.handleBlur} onChange={formik?.handleChange} disabled={!edit} />
                                {formik?.touched?.address && formik?.errors?.address && <div className="flex gap-[6px] items-start"><Warn />
                                    <span className="text-danger dark:text-darkDanger text-xs font-medium">{formik?.errors?.address}</span>
                                </div>}
                            </div>

                            <div className="grid w-full grid-cols-1 md:grid-cols-3 gap-[15px] xlx:gap-[20px]">
                                <div className="flex flex-col gap-[4px]">
                                    <PrimaryInput title={`${t("recruitment.profile.field.city")}*`} type="text" name="city" placeholder={t("recruitment.profile.field.city")} value={formik?.values?.city} onBlur={formik?.handleBlur} onChange={formik?.handleChange} disabled={!edit} />
                                    {formik?.touched?.city && formik?.errors?.city && <div className="flex gap-[6px] items-start"><Warn />
                                        <span className="text-danger dark:text-darkDanger text-xs font-medium">{formik?.errors?.city}</span>
                                    </div>}
                                </div>

                                <div className="flex flex-col gap-[4px]">
                                    <h6 className="text-blackDark dark:text-textBlackDark font-medium">{`${t("recruitment.profile.field.state")}*`}</h6>
                                    <SelectSecondaryComponent
                                        options={stateList}
                                        name="state"
                                        placeholder={t("recruitment.profile.placehoder.state")}
                                        isSearchable={false}
                                        arrow={true}
                                        components={{ DropdownIndicator }}
                                        onChange={(e: any) => formik.setFieldValue("state", e)}
                                        onBlur={(e: any) => formik.setFieldTouched("state", e)}
                                        value={!!formik.values.state ? stateList?.find((item: any) => item?.value === formik.values.state?.value) : formik.values.state}
                                        isDisabled={!edit}
                                    />
                                    {formik?.touched?.state && formik?.errors?.state && <div className="flex gap-[6px] items-start"><Warn />
                                        <span className="text-danger dark:text-darkDanger text-xs font-medium">{formik?.errors?.state}</span>
                                    </div>}
                                </div>

                                <div className="flex flex-col gap-[4px]">
                                    <PrimaryInput title={`${t("recruitment.profile.field.zipcode")}*`} type="number" name="zipcode" placeholder={t("recruitment.profile.field.zipcode")} value={formik?.values?.zipcode} onBlur={formik?.handleBlur} onChange={formik?.handleChange} exceptThisSymbols={["e", "E", "+", "-", "."]} disabled={!edit} />
                                    {formik?.touched?.zipcode && formik?.errors?.zipcode && <div className="flex gap-[6px] items-start"><Warn />
                                        <span className="text-danger dark:text-darkDanger text-xs font-medium">{formik?.errors?.zipcode}</span>
                                    </div>}
                                </div>
                            </div>

                            <div className="flex items-center gap-[8px] xlx:gap-[12px] mt-[10px] xlx:mt-[20px]">
                                <h5 className="text-primaryText dark:text-white font-bold whitespace-nowrap">{t("recruitment.profile.field.sign")}{!!params?.jobId && "*"}</h5>
                                <div className="border-b border-primaryText dark:border-white w-full border-opacity-[0.6]"></div>
                            </div>

                            <SignatureFile submit={submit} formik={formik} setUpdSign={setUpdSign} updSign={updSign} setDisSign={setDisSign} data={data} signErr={signErr} setSignErr={setSignErr} subFileErr={subFileErr} sign={sign} setSign={setSign} signPro={signPro} setSignPro={setSignPro} type={!edit ? "edit" : ""} />

                            <div className="flex items-center gap-[8px] xlx:gap-[12px] mt-[10px] xlx:mt-[20px]">
                                <h5 className="text-primaryText dark:text-white font-bold whitespace-nowrap">{t("recruitment.profile.field.emp_depu")}</h5>
                                <div className="border-b border-primaryText dark:border-white w-full border-opacity-[0.6]"></div>
                            </div>

                            <div className="flex flex-col gap-[4px] mt-[-10px] xsm:mt-[-15px] xlx:mt-[-20px]">
                                <h6 className="text-blackDark dark:text-textBlackDark font-medium">{t("recruitment.profile.field.work_mmrcl")}</h6>
                                <div className="flex items-center gap-[10px]">
                                    {Array.isArray(choice) && choice?.map((item: any, index: number) => (
                                        <button key={index} className={`${internal === item?.value ? "border border-primary bg-primary text-white focus:shadow-[0_0_0_2px_#059db25e] hover:shadow-[0_0_0_2px_#059db25e]" : "border border-blackDull bg-white text-blackDull focus:shadow-[0_0_0_2px_#4e566d5e] hover:shadow-[0_0_0_2px_#4e566d5e] dark:focus:shadow-[0_0_0_2px_#ffffff5e] dark:hover:shadow-[0_0_0_2px_#ffffff5e]"} rounded-[10px] h-[35px] xlx:h-[40px] px-[12px] leading-snug font-normal disabled:opacity-[0.7] disabled:shadow-none disabled:dark:shadow-none`} disabled={!edit} onClick={() => setInternal(!internal)}>{item?.label}</button>
                                    ))}
                                </div>
                            </div>

                            <div className={`flex flex-col gap-[4px] ${internal && "opacity-[0.5]"}`}>
                                <h6 className="text-blackDark dark:text-textBlackDark font-medium">{t("recruitment.profile.field.deputation")}</h6>
                                <div className="flex items-center gap-[10px]">
                                    {Array.isArray(choice) && choice?.map((item: any, index: number) => (
                                        <button key={index} className={`${(dep === item?.value && !internal) ? "border border-primary bg-primary text-white focus:shadow-[0_0_0_2px_#059db25e] hover:shadow-[0_0_0_2px_#059db25e]" : "border border-blackDull bg-white text-blackDull focus:shadow-[0_0_0_2px_#4e566d5e] hover:shadow-[0_0_0_2px_#4e566d5e] dark:focus:shadow-[0_0_0_2px_#ffffff5e] dark:hover:shadow-[0_0_0_2px_#ffffff5e]"} rounded-[10px] h-[35px] xlx:h-[40px] px-[12px] text-sm leading-snug font-normal disabled:shadow-none disabled:dark:shadow-none disabled:opacity-[0.7]`} onClick={() => setDep(!dep)} disabled={internal || !edit}>{item?.label}</button>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </>
                }

                {step === 1 &&
                    <div className="w-full lgl:w-[580px] h-full flex flex-col gap-[15px] xsm:gap-[20px] xlx:gap-[30px]">
                        <div className="flex items-center gap-[8px] xlx:gap-[12px] w-full">
                            <h5 className="text-primaryText dark:text-white font-bold whitespace-nowrap">{t("recruitment.profile.field.edu_details")}</h5>
                            <div className="border-b border-primaryText dark:border-white w-full border-opacity-[0.6]"></div>
                        </div>

                        {/* card */}
                        {formik?.values?.educations?.length > 0 && <div className={`flex flex-col gap-[15px] ${(editEdu === 0 && formik?.values?.educations?.length === 1) && "hidden"}`}>
                            {Array.isArray(formik?.values?.educations) && formik?.values?.educations?.map((item: any, index: number) => (
                                <React.Fragment key={index}>
                                    {(editEdu !== index) && <div className="border border-[#E5E5E5] bg-[#FCFCFC] dark:bg-[#2e3037] dark:border-[#454545]  py-[10px] px-[15px] xlx:py-[14px] xlx:px-[23px]">
                                        <div className=" flex w-full justify-between md:items-center pb-[8px] border-b border-[#000] dark:border-[#ffffff] dark:border-opacity-[0.2] border-opacity-[0.2]">
                                            <div className="flex flex-col gap-[5px]">
                                                <h5 className="text-primary font-bold">{item?.institute_name}</h5>
                                                <h6 className="text-blackDark dark:text-textBlackDark font-semibold">{item?.specialization_name}</h6>
                                                <div className="items-center gap-[5px] xlx:gap-[7px] md:hidden flex">
                                                    <Leave className="fill-blackDark dark:fill-textBlackDark w-[14px] h-[14px] min-w-[14px]" />
                                                    <h6 className="text-blackDark dark:text-textBlackDark font-semibold mt-[2px]">{moment(item?.start_date).format('MMM YYYY')} - {moment(item?.end_date).format('MMM YYYY')}</h6>
                                                </div>
                                            </div>

                                            <div className="flex flex-col gap-[5px] xlx:gap-[10px] items-end">
                                                {edit && <div className="flex items-center gap-[8px]">
                                                    <button aria-label={t("aria_label.edit_edu")} title={t("aria_label.edit_edu")} className="min-w-[26px] h-[26px] flex items-center justify-center bg-[#D9D9D9] dark:bg-[#5c5858] rounded-[4px] bg-opacity-[0.4] border border-transparent focus:border-[#059DB25e] hover:border-[#059DB25e]" onClick={() => setEditEdu(index)}><Edit className="fill-primary" /> </button>
                                                    <button aria-label={t("aria_label.delete_edu")} title={t("aria_label.delete_edu")} className="min-w-[26px] h-[26px] flex items-center justify-center bg-[#D9D9D9] dark:bg-[#5c5858] rounded-[4px] bg-opacity-[0.4] border border-transparent focus:border-[#FF00005e] hover:border-[#FF00005e] dark:focus:border-[#FF5B5B5e] dark:hover:border-[#FF5B5B5e]" onClick={() => removeEdu(index)}><Delete /> </button>
                                                </div>}

                                                <div className="items-center gap-[5px] xlx:gap-[7px] md:flex hidden">
                                                    <Leave className="fill-blackDark dark:fill-textBlackDark w-[14px] h-[14px] min-w-[14px]" />
                                                    <h6 className="text-blackDark dark:text-textBlackDark font-semibold mt-[2px]">{moment(item?.start_date).format('MMM YYYY')} - {moment(item?.end_date).format('MMM YYYY')}</h6>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="flex items-center flex-wrap w-full pt-[8px] gap-y-[10px] gap-x-[25px]">
                                            <div className="flex flex-col gap-[4px]">
                                                <p className="text-blackDull dark:text-textBlackDull font-semibold">{t("recruitment.hr.candidate_detail.standard")}</p>
                                                <h6 className="text-blackDark dark:text-textBlackDark font-bold uppercase">{item?.standard_name}</h6>
                                            </div>
                                            <div className="flex flex-col gap-[4px]">
                                                <p className="text-blackDull dark:text-textBlackDull font-semibold">{t("recruitment.hr.candidate_detail.board")}</p>
                                                <h6 className="text-blackDark dark:text-textBlackDark font-bold uppercase">{item?.board_name}</h6>
                                            </div>
                                            <div className="flex flex-col gap-[4px]">
                                                <p className="text-blackDull dark:text-textBlackDull font-semibold">{t("recruitment.hr.candidate_detail.percent")}</p>
                                                <h6 className="text-blackDark dark:text-textBlackDark font-bold uppercase">{item?.per_cgpa}</h6>
                                            </div>
                                            <div className="flex flex-col gap-[4px]">
                                                <p className="text-blackDull dark:text-textBlackDull font-semibold">{t("recruitment.hr.candidate_detail.results")}</p>
                                                <h6 className="text-blackDark dark:text-textBlackDark font-bold uppercase">{item?.result}</h6>
                                            </div>
                                            <div className="flex flex-col gap-[4px]">
                                                <p className="text-blackDull dark:text-textBlackDull font-semibold">{t("recruitment.hr.candidate_detail.mode")}</p>
                                                <h6 className="text-blackDark dark:text-textBlackDark font-bold uppercase">{modes?.find((i: any) => item?.mode === i?.value)?.label}</h6>
                                            </div>
                                        </div>
                                    </div>}
                                </React.Fragment>
                            ))}

                            {(!createEdu && !!!editEdu && editEdu !== 0 && edit) && <div className="flex items-end justify-end w-full">
                                <SecondaryBtn title={t("recruitment.profile.field.add")} css="px-[13px] font-semibold rounded-[6px] text-sm leading-snug !gap-[6px] !h-[35px]" leftIcon={<Add />} onClick={() => setCreateEdu(true)} />
                            </div>}
                        </div>}

                        {/* form */}
                        {(createEdu || !!editEdu || editEdu === 0 || formik?.values?.educations?.length === 0) && <Educations formik={formik} qualificationList={qualificationList} DropdownIndicator={DropdownIndicator} works={works} setCreateEdu={setCreateEdu} editEdu={editEdu} setEditEdu={setEditEdu} eduDate={eduDate} setEduDate={setEduDate} setResultIdx={setResultIdx} results={results} modes={modes} />}

                        <div className="flex items-center gap-[8px] xlx:gap-[12px] w-full">
                            <h5 className="text-primaryText dark:text-white font-bold whitespace-nowrap">{t("recruitment.profile.field.emp_details")}</h5>
                            <div className="border-b border-primaryText dark:border-white w-full border-opacity-[0.6]"></div>
                        </div>

                        {/* card */}
                        {formik?.values?.experiences?.length > 0 && <div className={`flex flex-col gap-[15px] ${(editExp === 0 && formik?.values?.experiences?.length === 1) && "hidden"}`}>
                            {Array.isArray(formik?.values?.experiences) && formik?.values?.experiences?.map((item: any, index: number) => (
                                <React.Fragment key={index}>
                                    {(editExp !== index) && <div className="border border-[#E5E5E5] bg-[#FCFCFC] dark:bg-[#2e3037] dark:border-[#454545] py-[10px] px-[15px] xlx:py-[14px] xlx:px-[23px]">
                                        <div className=" flex w-full justify-between md:items-center pb-[8px] border-b border-[#000] border-opacity-[0.2] dark:border-[#ffffff] dark:border-opacity-[0.2]">
                                            <div className="flex flex-col gap-[5px]">
                                                <h5 className="text-primary font-bold">{item?.company_name}</h5>
                                                <h6 className="text-blackDark dark:text-textBlackDark font-semibold">{item?.job_title}</h6>
                                                <div className="items-center gap-[5px] xlx:gap-[7px] md:hidden flex">
                                                    <Leave className="fill-blackDark dark:fill-textBlackDark w-[14px] h-[14px] min-w-[14px]" />
                                                    <h6 className="text-blackDark dark:text-textBlackDark font-semibold mt-[2px]">{moment(item?.start_date).format('MMM YYYY')} - {item?.currently_working ? t("recruitment.hr.candidate_detail.present") : moment(item?.end_date).format('MMM YYYY')}</h6>
                                                </div>
                                            </div>

                                            <div className="flex flex-col gap-[5px] xlx:gap-[10px] items-end">
                                                {edit && <div className="flex items-center gap-[8px]">
                                                    <button aria-label={t("aria_label.edit_emp")} title={t("aria_label.edit_emp")} className="min-w-[26px] h-[26px] flex items-center justify-center bg-[#D9D9D9] dark:bg-[#5c5858] rounded-[4px] bg-opacity-[0.4] focus:border-[#059DB25e] hover:border-[#059DB25e]" onClick={() => setEditExp(index)}><Edit className="fill-primary" /> </button>
                                                    <button aria-label={t("aria_label.delete_emp")} title={t("aria_label.delete_emp")} className="min-w-[26px] h-[26px] flex items-center justify-center bg-[#D9D9D9] dark:bg-[#5c5858] rounded-[4px] bg-opacity-[0.4] focus:border-[#FF00005e] hover:border-[#FF00005e] dark:focus:border-[#FF5B5B5e] dark:hover:border-[#FF5B5B5e]" onClick={() => removeExp(index)}><Delete /> </button>
                                                </div>}

                                                <div className="items-center gap-[5px] xlx:gap-[7px] md:flex hidden">
                                                    <Leave className="fill-blackDark dark:fill-textBlackDark w-[14px] h-[14px] min-w-[14px]" />
                                                    <h6 className="text-blackDark dark:text-textBlackDark font-semibold mt-[2px]">{moment(item?.start_date).format('MMM YYYY')} - {item?.currently_working ? t("recruitment.hr.candidate_detail.present") : moment(item?.end_date).format('MMM YYYY')}</h6>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="flex items-center flex-wrap w-full py-[8px] gap-y-[10px] gap-x-[25px] border-b border-[#000] border-opacity-[0.2] dark:border-[#ffffff] dark:border-opacity-[0.2]">
                                            <div className="flex flex-col gap-[4px]">
                                                <p className="text-blackDull dark:text-textBlackDull font-semibold">{t("recruitment.hr.candidate_detail.cur_emp")}</p>
                                                <h6 className="text-blackDark dark:text-textBlackDark font-bold uppercase">{item?.employment_name}</h6>
                                            </div>
                                            <div className="flex flex-col gap-[4px]">
                                                <p className="text-blackDull dark:text-textBlackDull font-semibold">{t("recruitment.hr.candidate_detail.job_category")}</p>
                                                <h6 className="text-blackDark dark:text-textBlackDark font-bold uppercase">{item?.experience_type_name}</h6>
                                            </div>
                                            {item?.employment === "private" ? <div className="flex flex-col gap-[4px]">
                                                <p className="text-blackDull dark:text-textBlackDull font-semibold">{t("recruitment.home.job_list.pay_scale")}</p>
                                                <h6 className="text-blackDark dark:text-textBlackDark font-bold uppercase">₹ {item?.pay_scale}</h6>
                                            </div> : <>
                                                <div className="flex flex-col gap-[4px]">
                                                    <p className="text-blackDull dark:text-textBlackDull font-semibold">{t("recruitment.home.job_list.pay_scale")}</p>
                                                    <h6 className="text-blackDark dark:text-textBlackDark font-bold uppercase">{item?.pay_scale_gov}</h6>
                                                </div>
                                                <div className="flex flex-col gap-[4px]">
                                                    <p className="text-blackDull dark:text-textBlackDull font-semibold">{t("recruitment.hr.candidate_detail.basic_pay")}</p>
                                                    <h6 className="text-blackDark dark:text-textBlackDark font-bold uppercase">₹ {item?.basic_pay}</h6>
                                                </div>
                                            </>}
                                            <div className="flex flex-col gap-[4px]">
                                                <p className="text-blackDull dark:text-textBlackDull font-semibold">{t("recruitment.home.job_list.emp")}</p>
                                                <h6 className="text-blackDark dark:text-textBlackDark font-bold uppercase">{item?.employment_type_name}</h6>
                                            </div>
                                        </div>
                                        <div className="flex items-center gap-[5px] xlx:gap-[8px] mt-[8px]">
                                            <Location />
                                            <h6 className="text-blackDark dark:text-textBlackDark font-semibold ">{item?.location}</h6>
                                        </div>
                                    </div>}
                                </React.Fragment>
                            ))}

                            {(!createExp && !!!editExp && editExp !== 0 && edit) && <div className="flex items-end justify-end w-full">
                                <SecondaryBtn title={t("recruitment.profile.field.add")} css="px-[13px] font-semibold rounded-[6px] text-sm leading-snug !gap-[6px] !h-[35px]" leftIcon={<Add />} onClick={() => setCreateExp(true)} />
                            </div>}
                        </div>}

                        {/* form */}
                        {(createExp || !!editExp || editExp === 0 || formik?.values?.experiences?.length === 0) && <Experiences formik={formik} typeList={typeList} DropdownIndicator={DropdownIndicator} works={works} setCreateExp={setCreateExp} editExp={editExp} setEditExp={setEditExp} submit={submit} workingIdx={workingIdx} setWorkingIdx={setWorkingIdx} expDate={expDate} setExpDate={setExpDate} createExp={createExp} exeType={exeType} employement={employement} />}

                        <div className="flex items-center gap-[8px] xlx:gap-[12px] w-full">
                            <h5 className="text-primaryText dark:text-white font-bold whitespace-nowrap">{t("recruitment.profile.field.summary_details")}</h5>
                            <div className="border-b border-primaryText dark:border-white w-full border-opacity-[0.6]"></div>
                        </div>

                        <div className="grid w-full grid-cols-1 md:grid-cols-2 gap-[15px] xlx:gap-[20px]">
                            <div className="flex flex-col gap-[3px]">
                                <h6 className="text-blackDark dark:text-textBlackDark font-medium">{t("recruitment.profile.field.total_exp")}</h6>

                                <h6 className="text-blackDark dark:text-textBlackDark font-semibold">{!!tExp ? ((tExp?.totalYears > 0 && tExp?.totalMonths > 0) ? `${tExp?.totalYears} ${tExp?.totalYears > 1 ? t("recruitment.profile.field.years") : t("recruitment.profile.field.year")} ${tExp?.totalMonths} ${tExp?.totalMonths > 1 ? t("recruitment.profile.field.months") : t("recruitment.profile.field.month")}` : tExp?.totalYears > 0 ? `${tExp?.totalYears} ${tExp?.totalYears > 1 ? t("recruitment.profile.field.years") : t("recruitment.profile.field.year")}` : `1 ${t("recruitment.profile.field.month")}`) : "-"}</h6>
                            </div>

                            <div className="flex flex-col gap-[3px]">
                                <h6 className="text-blackDark dark:text-textBlackDark font-medium">{t("recruitment.profile.field.total_exe_exp")}</h6>

                                <h6 className="text-blackDark dark:text-textBlackDark font-semibold">{!!eTExp ? ((eTExp?.totalYears > 0 && eTExp?.totalMonths > 0) ? `${eTExp?.totalYears} ${eTExp?.totalYears > 1 ? t("recruitment.profile.field.years") : t("recruitment.profile.field.year")} ${eTExp?.totalMonths} ${eTExp?.totalMonths > 1 ? t("recruitment.profile.field.months") : t("recruitment.profile.field.month")}` : eTExp?.totalYears > 0 ? `${eTExp?.totalYears} ${eTExp?.totalYears > 1 ? t("recruitment.profile.field.years") : t("recruitment.profile.field.year")}` : `1 ${t("recruitment.profile.field.month")}`) : "-"}</h6>
                            </div>
                        </div>

                        <div className="flex flex-col gap-[4px]">
                            <PrimaryTextarea title={`${t("recruitment.profile.field.relevant_professional_experience")}*`} placeholder={t("recruitment.profile.placehoder.start_tying")} rows="4" name="relevant_professional_experience" value={formik?.values?.relevant_professional_experience} onBlur={formik?.handleBlur} onChange={formik?.handleChange} disabled={!edit} />
                            {formik?.touched?.relevant_professional_experience && formik?.errors?.relevant_professional_experience && <div className="flex gap-[6px] items-start"><Warn />
                                <span className="text-danger dark:text-darkDanger text-xs font-medium">{formik?.errors?.relevant_professional_experience}</span>
                            </div>}
                        </div>

                        {/* <div className="flex flex-col gap-[4px]">
                            <h6 className="text-blackDark dark:text-textBlackDark font-medium">{t("recruitment.profile.field.work_mmrcl")}</h6>
                            <div className="flex items-center gap-[10px]">
                                {Array.isArray(choice) && choice?.map((item: any, index: number) => (
                                    <button key={index} className={`${internal === item?.value ? "border border-primary bg-primary text-white focus:shadow-[0_0_0_2px_#059db25e] hover:shadow-[0_0_0_2px_#059db25e]" : "border border-blackDull bg-white text-blackDull focus:shadow-[0_0_0_2px_#4e566d5e] hover:shadow-[0_0_0_2px_#4e566d5e] dark:focus:shadow-[0_0_0_2px_#ffffff5e] dark:hover:shadow-[0_0_0_2px_#ffffff5e]"} rounded-[10px] h-[35px] xlx:h-[40px] px-[12px] leading-snug font-normal disabled:opacity-[0.7] disabled:shadow-none disabled:dark:shadow-none`} disabled={!edit} onClick={() => setInternal(!internal)}>{item?.label}</button>
                                ))}
                            </div>
                        </div>

                        <div className={`flex flex-col gap-[4px] ${internal && "opacity-[0.5]"}`}>
                            <h6 className="text-blackDark dark:text-textBlackDark font-medium">{t("recruitment.profile.field.deputation")}</h6>
                            <div className="flex items-center gap-[10px]">
                                {Array.isArray(choice) && choice?.map((item: any, index: number) => (
                                    <button key={index} className={`${(dep === item?.value && !internal) ? "border border-primary bg-primary text-white focus:shadow-[0_0_0_2px_#059db25e] hover:shadow-[0_0_0_2px_#059db25e]" : "border border-blackDull bg-white text-blackDull focus:shadow-[0_0_0_2px_#4e566d5e] hover:shadow-[0_0_0_2px_#4e566d5e] dark:focus:shadow-[0_0_0_2px_#ffffff5e] dark:hover:shadow-[0_0_0_2px_#ffffff5e]"} rounded-[10px] h-[35px] xlx:h-[40px] px-[12px] text-sm leading-snug font-normal disabled:shadow-none disabled:dark:shadow-none disabled:opacity-[0.7]`} onClick={() => setDep(!dep)} disabled={internal || !edit}>{item?.label}</button>
                                ))}
                            </div>
                        </div> */}
                    </div>
                }

                {step === 2 &&
                    <div className="w-full lgl:w-[580px] h-full flex flex-col gap-[15px] xsm:gap-[20px] xlx:gap-[30px]">
                        <div className="flex items-center gap-[8px] xlx:gap-[12px]">
                            <h5 className="text-primaryText dark:text-white font-bold whitespace-nowrap">{t("recruitment.profile.field.resume")} {!!params?.jobId && "*"}</h5>
                            <div className="border-b border-primaryText dark:border-white w-full border-opacity-[0.6]"></div>
                        </div>

                        <ResumeFile submit={submit} formik={formik} setUpdResume={setUpdResume} updResume={updResume} setDisResume={setDisResume} data={data} resumeErr={resumeErr} setResumeErr={setResumeErr} subFileErr={subFileErr} resume={resume} setResume={setResume} resumePro={resumePro} setResumePro={setResumePro} type={!edit ? "edit" : ""} />

                        <div className="flex items-center gap-[8px] xlx:gap-[12px]">
                            <h5 className="text-primaryText dark:text-white font-bold whitespace-nowrap">{t("recruitment.profile.field.exp_certi")}{!!params?.jobId && "*"}</h5>
                            <div className="border-b border-primaryText dark:border-white w-full border-opacity-[0.6]"></div>
                        </div>

                        <ExpCertiFile submit={submit} formik={formik} updExpCerti={updExpCerti} setUpdExpCerti={setUpdExpCerti} setDisExpCerti={setDisExpCerti} data={data} expCertiErr={expCertiErr} setExpCertiErr={setExpCertiErr} subFileErr={subFileErr} expCerti={expCerti} setExpCerti={setExpCerti} setExpCertiPro={setExpCertiPro} expCertiPro={expCertiPro} type={!edit ? "edit" : ""} />

                        <div className="flex items-center gap-[8px] xlx:gap-[12px]">
                            <h5 className="text-primaryText dark:text-white font-bold whitespace-nowrap">{t("recruitment.profile.field.edu_certi")}{!!params?.jobId && "*"}</h5>
                            <div className="border-b border-primaryText dark:border-white w-full border-opacity-[0.6]"></div>
                        </div>

                        <EduCertificateFile submit={submit} formik={formik} setUpdEduCerti={setUpdEduCerti} updEduCerti={updEduCerti} setDisEduCerti={setDisEduCerti} data={data} eduCertiErr={eduCertiErr} setEduCertiErr={setEduCertiErr} subFileErr={subFileErr} eduCerti={eduCerti} setEduCerti={setEduCerti} eduCertiPro={eduCertiPro} setEduCertiPro={setEduCertiPro} type={!edit ? "edit" : ""} />

                        <div className="flex items-center gap-[8px] xlx:gap-[12px]">
                            <h5 className="text-primaryText dark:text-white font-bold whitespace-nowrap">{t("recruitment.profile.field.pay_slip")}{!!params?.jobId && "*"}</h5>
                            <div className="border-b border-primaryText dark:border-white w-full border-opacity-[0.6]"></div>
                        </div>

                        <PaySlipFile submit={submit} formik={formik} setUpdPaySlip={setUpdPaySlip} updPaySlip={updPaySlip} setDisPaySlip={setDisPaySlip} data={data} paySlipErr={paySlipErr} setPaySlipErr={setPaySlipErr} subFileErr={subFileErr} paySlip={paySlip} setPaySlip={setPaySlip} paySlipPro={paySlipPro} setPaySlipPro={setPaySlipPro} type={!edit ? "edit" : ""} />

                        <div className="flex flex-col gap-[4px]">
                            <div className="flex items-center gap-[8px] xlx:gap-[12px]">
                                <h5 className="text-primaryText dark:text-white font-bold whitespace-nowrap">{t("recruitment.profile.field.gov_id")}{!!params?.jobId && "*"}</h5>
                                <div className="border-b border-primaryText dark:border-white w-full border-opacity-[0.6]"></div>
                            </div>
                            <p className="text-blackDark dark:text-textBlackDark font-bold mb-[2px] flex gap-[6px] items-start"><Info /> {t("recruitment.profile.field.gov_id_desc")}</p>
                        </div>

                        <GovIDFile submit={submit} formik={formik} setUpdGovID={setUpdGovID} updGovID={updGovID} setDisGovID={setDisGovID} data={data} setGovIDErr={setGovIDErr} govIDErr={govIDErr} subFileErr={subFileErr} govID={govID} setGovID={setGovID} govIDPro={govIDPro} setGovIDPro={setGovIDPro} type={!edit ? "edit" : ""} />

                        {(formik?.values?.category?.label === "OBC" || formik?.values?.category?.label === "ST" || formik?.values?.category?.label === "SC") && <>
                            <div className="flex flex-col gap-[4px]">
                                <div className="flex items-center gap-[8px] xlx:gap-[12px]">
                                    <h5 className="text-primaryText dark:text-white font-bold whitespace-nowrap">{t("recruitment.profile.field.cast_certi")}</h5>
                                    <div className="border-b border-primaryText dark:border-white w-full border-opacity-[0.6]"></div>
                                </div>
                                <p className="text-blackDark dark:text-textBlackDark font-bold mb-[2px] flex gap-[6px] items-start"><Info /> {t("recruitment.profile.field.cast_certi_desc")}</p>
                            </div>

                            <CastCertificate submit={submit} formik={formik} setUpdCastCerti={setUpdCastCerti} updCastCerti={updCastCerti} setDisCastCerti={setDisCastCerti} data={data} castCertiErr={castCertiErr} setCastCertiErr={setCastCertiErr} subFileErr={subFileErr} castCerti={castCerti} setCastCerti={setCastCerti} setCastCertiPro={setCastCertiPro} castCertiPro={castCertiPro} type={!edit ? "edit" : ""} />
                        </>}

                        {formik?.values?.category?.label === "OBC" && <><div className="flex flex-col gap-[4px]">
                            <div className="flex items-center gap-[8px] xlx:gap-[12px]">
                                <h5 className="text-primaryText dark:text-white font-bold whitespace-nowrap">{t("recruitment.profile.field.non_creamy_certi")}</h5>
                                <div className="border-b border-primaryText dark:border-white w-full border-opacity-[0.6]"></div>
                            </div>
                            <p className="text-blackDark dark:text-textBlackDark font-bold mb-[2px] flex gap-[6px] items-start"><Info /> {t("recruitment.profile.field.non_creamy_certi_desc")}</p>
                        </div>

                            <NoneCreamyCertificate submit={submit} formik={formik} setUpdNonCreamyCerti={setUpdNonCreamyCerti} updNonCreamyCerti={updNonCreamyCerti} setDisNonCreamyCerti={setDisNonCreamyCerti} data={data} nonCreamyCertiErr={nonCreamyCertiErr} setNonCreamyCertiErr={setNonCreamyCertiErr} subFileErr={subFileErr} nonCreamyCerti={nonCreamyCerti} setNonCreamyCerti={setNonCreamyCerti} setNonCreamyCertiPro={setNonCreamyCertiPro} nonCreamyCertiPro={nonCreamyCertiPro} type={!edit ? "edit" : ""} />
                        </>}

                        {formik?.values?.category?.label === "EWS" && <>
                            <div className="flex flex-col gap-[4px]">
                                <div className="flex items-center gap-[8px] xlx:gap-[12px]">
                                    <h5 className="text-primaryText dark:text-white font-bold whitespace-nowrap">{t("recruitment.profile.field.ews")}{!!params?.jobId && "*"} {t("recruitment.profile.field.if_applicable")}</h5>
                                    <div className="border-b border-primaryText dark:border-white w-full border-opacity-[0.6]"></div>
                                </div>
                                {/* <p className="text-blackDark dark:text-textBlackDark font-bold mb-[2px] flex gap-[6px] items-start"><Info /> Valid OBC certificate should be uploaded with non-creamy layer certificate if applicable</p> */}
                            </div>

                            <EWSCertificate submit={submit} formik={formik} setUpdEWSCerti={setUpdEWSCerti} updEWSCerti={updEWSCerti} setDisEWSCerti={setDisEWSCerti} data={data} ewsCertiErr={ewsCertiErr} setEwsCertiErr={setEwsCertiErr} subFileErr={subFileErr} ewsCerti={ewsCerti} setEwsCerti={setEwsCerti} setEwsCertiPro={setEwsCertiPro} ewsCertiPro={ewsCertiPro} type={!edit ? "edit" : ""} />
                        </>}
                    </div>
                }
            </div>
        </div>
    );
};

export default EditProfile;